import customerFeedbackTemplate from './customer-feedback';
import productRecommendationQuizTemplate from './product-recommendation-quiz';
import eCommerceLeadCaptureQuizTemplate from './e-commerce-lead-capture-quiz';
import customerEffortScoreSurveyTemplate from './customer-effort-score-survey';
import leadGenerationSurveyTemplate from './lead-generation-survey';
import employeeFeedbackFormTemplate from './employee-feedback-form';
import clientReferralFormTemplate from './client-referral-form';
import demoFeedbackFormTemplate from './demo-feedback-form';
import leadCaptureFormTemplate from './lead-capture-form';
import competitorResearchSurveyTemplate from './competitor-research-survey';
import kycFormTemplate from './kyc-form';
import eventSignupFormTemplate from './event-signup-form';
import presentationFeedbackSurveyTemplate from './presentation-feedback-survey';
import leadQualificationFormTemplate from './lead-qualification-form';
import websiteDesignFeedbackFormTemplate from './website-design-feedback-form';
import testimonialFormTemplate from './testimonial-form';
import clientSatisfactionSurveyTemplate from './client-satisfaction-survey';
import designRequestFormTemplate from './design-request-form';
import productResearchSurveyTemplate from './product-research-survey';
import betaProductFeedbackSurveyTemplate from './beta-product-feedback-survey';
import onlineQuoteFormTemplate from './online-quote-form';
import softwareDevelopmentQuizTemplate from './software-development-quiz';
import triviaQuizTemplate from './trivia-quiz';
import brandingQuestionnaireTemplate from './branding-questionnaire';
import postEventFeedbackSurveyTemplate from './post-event-feedback-survey';
import marketResearchSurveyTemplate from './market-research-survey';
import { TemplateItem } from './types';
import themes from './inputData/_themes';

export const templates = [
  productRecommendationQuizTemplate,
  leadCaptureFormTemplate,
  testimonialFormTemplate,
  websiteDesignFeedbackFormTemplate,
  designRequestFormTemplate,
  triviaQuizTemplate,
  postEventFeedbackSurveyTemplate,
  eCommerceLeadCaptureQuizTemplate,
  betaProductFeedbackSurveyTemplate,
  presentationFeedbackSurveyTemplate,
  leadQualificationFormTemplate,
  customerEffortScoreSurveyTemplate,
  leadGenerationSurveyTemplate,
  employeeFeedbackFormTemplate,
  clientReferralFormTemplate,
  demoFeedbackFormTemplate,
  competitorResearchSurveyTemplate,
  kycFormTemplate,
  eventSignupFormTemplate,
  clientSatisfactionSurveyTemplate,
  marketResearchSurveyTemplate,
  productResearchSurveyTemplate,
  onlineQuoteFormTemplate,
  softwareDevelopmentQuizTemplate,
  brandingQuestionnaireTemplate,
];


export { themes };
export type { TemplateItem, TemplateInput, FilterTypes } from './types';

export const getTemplateById = (id: string): TemplateItem => {
  const template = templates.find((template) => template.id === id);

  if (!template) throw new Error(`Template with ID ${id} not found`);

  return template;
}